import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
/** PERSONAL */
import Stem from './Stem';
import Footer from '../Footer';
import { reverseParseTextView } from './createRender';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        
        const visible = props.showAnswer ? true : false;

        this.state = {
            visible: visible,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        this.MQLoad();

        if (this.props.hasOwnProperty('showAllAnswer') && this.props.showAllAnswer !== prevProps.showAllAnswer) {
            this.setState({ visible: this.props.showAllAnswer });
            this.drawLine(this.props.showAllAnswer);
        }
    }

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            MQ.StaticMath(item);
        });
    };

    // 显示答案
    toggleAnswer = (val) => {
        this.setState({ visible: val });
        this.drawLine(val);
    };

    // 导出题目
    handleExport = () => {
        const { handleExport } = this.props;
        handleExport && handleExport();
    };

    // 获取替换题目列表
    getReplaceQuestion = () => {
        const { getReplaceQuestion } = this.props;
        getReplaceQuestion && getReplaceQuestion();
    };

    // 更换题目
    handleReplace = () => {
        const { handleReplace } = this.props;
        handleReplace && handleReplace();
    };

    drawLine = (val) => {
        const { answer } = this.state.data;
        const rightAnswer = answer[0].content;

        let c = findDOMNode(this).querySelector('#canvas');
        let ctx = c.getContext("2d");
        if (val) {
            // 设置canvas高度
            let lh = $(c).prev().outerHeight();
            let rh = $(c).next().outerHeight();
            c.height = lh > rh ? lh * 2 : rh * 2;
            c.style.height = lh > rh ? lh : rh + 'px';

            ctx.beginPath();
            ctx.lineCap = "round";
            ctx.lineWidth = 5;
            ctx.strokeStyle = '#00afff';
            const l_list = $(c).prev(), r_list = $(c).next();

            for (let key in rightAnswer) {
                const l_item = l_list.find(`.guide-item[data-id="${key}"]`);

                rightAnswer[key].forEach(item => {
                    const r_item = r_list.find(`.guide-item[data-id="${item}"]`);

                    ctx.moveTo(10, (l_item.outerHeight() / 2 + l_item.position().top) * 2);
                    ctx.lineTo(490, (r_item.outerHeight() / 2 + r_item.position().top) * 2);
                });
            }
            ctx.stroke();
        } else {
            c.height = c.height;
        }
    };

    render() {
        const { visible, data } = this.state;
        const { stem } = data;
        const { num, canShowAnswer, canExport, canRelpace, handleReplace, exported } = this.props;
        const classname = classnames('question-wrapper', 'question-line', {
            'exported': exported
        });

        return (
            <div className={classname} ref={(el) => this.viewer = el}>
                <div className="question-content">
                    <div className="question-order">
                        <p className="math_text"><span>{`${num + 1}.`}</span></p>
                    </div>
                    <div className="question-stem">
                        <Stem stem={stem} />
                    </div>
                </div>
                <div className="question-footer">
                    <div className="footer-show">
                        <Footer {...this.props}>
                            {
                                canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible, e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }
                            {
                                canExport ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleExport}>
                                        {!exported ? '选择' : '取消'}
                                    </button> : null
                            }
                            {
                                canRelpace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.getReplaceQuestion}>更换此题</button> : null
                            }
                            {
                                handleReplace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleReplace}>选择</button> : null
                            }
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/pair/view.js